import { useTranslation } from 'react-i18next';

import { getIntlLocale } from '@i18n';
import ShareCardModal from '@modals/Share/ShareCardModal';

/**
 * ShareCommunityModal — the share card named for a community: its logo, name
 * and member count over the public link. Everything else (stage, channels,
 * tints, PNG export) belongs to ShareCardModal.
 *
 * The link carries `?shared=true`, which the community page reads to open the
 * invitation for a visitor who isn't a member yet; the card prints the address
 * without it.
 */
export default function ShareCommunityModal({ open, community, onClose }) {
    const { t } = useTranslation('community');

    if (!community?.slug) return null;

    const members = community.members?.total ?? 0;

    return (
        <ShareCardModal
            open={open}
            url={`${window.location.origin}/${community.slug}?shared=true`}
            displayUrl={`${window.location.host}/${community.slug}`}
            onClose={onClose}
            title={t('share.title')}
            subtitle={t('share.subtitle')}
            shareText={t('share.shareText', { name: community.name || '' })}
            fileSlug={community.slug}
            card={{
                name: community.name,
                caption: members > 0
                    ? t('share.members', { count: members, value: members.toLocaleString(getIntlLocale()) })
                    : undefined,
                image: community.banner,
                shape: 'squircle',
            }}
        />
    );
}
